<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {toastbox} from '../../../utils.js';
    import {validate_int, validate_not_empty} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import PodokonnikMaterialList from "../../parts/PodokonnikMaterialList.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;


    //Золотой дуб, матовый, гладкий
   // Подоконник, 350x600, тип STANDARD by TM DANKE, цвет Золотой дуб, матовый, гладкий

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar)

           // let title = item.title.replace(', цвет' + item.params.ind2 , '').split(', ');

            let title = item.title.split(', цвет ')[0].split(', ');

            width = title[1].split('x')[0];
            dlina = +title[1].split('x')[1];

            ind2 = item.title.split(', цвет ')[1];
            ind1 = title[2].replace('тип ' , '');

            count.set(+item.quantity);
            comment.set(item.comment);
            components = JSON.parse(atob(fetched.ind3))
            fetchData = await fetch(ind1);
                        await changeInd1()
            change();
        }
    };

    let components = {}

    const tip = {
        'ПВХ': 'ПВХ',
        'STANDARD by TM DANKE': 'STANDARD by TM DANKE',
        'KOMFORT by TM DANKE': 'KOMFORT by TM DANKE',
        'PREMIUM TM DANKE': 'PREMIUM TM DANKE',
    };

    const fetch = async (ind1 = 'ПВХ') => {
        let result = await network.fetch_data('Подоконник',ind1);

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            materials: result.filter((item) => (item.ind3 === '1' && item.flag === '1' )),
            result,
        }
    }

    let dlina = 600,
        width = '100',
        ind2 = 'Белый', // цвет RAL
        ind3 = '', // тип
        ind1 = 'ПВХ', //
        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1);

    let fetchData = fetch(ind1);
    let title;

    const changeInd1 = async () => {
        fetchData = await fetch(ind1);
        let data = await fetchData;

        ind2 = Object.keys(data.ind2).find((e) => e.length)

        changeInd2()
    };

    const changeInd2 = async () => {
        let data = await fetchData;
        let first = Object.keys(data.ind2).find((e) => e.length);

        width = data.ind2[first][0].ind1
    };

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count;
            title = [
                'Подоконник, ', width + 'x' + dlina, ', тип ', ind1, ', цвет ', ind2
            ].join('');

        let result = {
            type: 'Подоконник',
            name: 'Подоконник',
            subname: title.replace('Подоконник, ', ''),
            title: title,
            params: {
                ind1: '',
                ind2: ind2,
                ind3: btoa(JSON.stringify(components)),
                ind4: width.replace('(2 Уха)', '').replace('(1 ухо)', ''),
                ind5: dlina,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: 75
        };

        let title_addons = []

        _.forEach(data.result, function (el) {
            let item = _.cloneDeep(el);
            let name = item.name.toLowerCase();
            let cvet = item.ind2.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (ind2.toLowerCase() ==cvet && width.toLowerCase() == item.ind1.toLowerCase()) {
                /*console.log(parseInt(width));*/

                kolvo = (dlina/1000).toFixed(3);
            }

            if (components.hasOwnProperty(item.idTovar)) {
                kolvo = +components[item.idTovar]['count'];

                let edIzmer = item.edIzmer.length ? item.edIzmer : 'шт.'
                title_addons.push(`${item.name} - ${kolvo}/${edIzmer}`)
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
        });

        result.title = `${result.title} | ${title_addons.join(', ')}`

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);

        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    {@const colors = Object.keys(data.ind2).filter(value => value.trim() !== "").sort((a, b) => a.localeCompare(b, "ru"))}
  <!-- <pre>{JSON.stringify(components, null, 4)}</pre>-->

    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="form-group boxed">
                    <img style="max-height: 250px" class="img-fluid px-3" src="/img/podokonnik/{ind2}.jpg" />
                </div>
            </div>

            <div class="col-12 col-md-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Тип</label>
                        <select class="form-control form-select" bind:value={ind1} on:change={() => {changeInd1();  change()}}>
                            {#each Object.entries(tip) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>

                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет Ral</label>
                        <select class="form-control form-select" bind:value={ind2} on:change={() => {changeInd2(); change()}}>
                            {#each colors as value}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>

                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Ширина, мм</label>
                        <select class="form-control form-select" bind:value={width} on:change={() => {change()}}>
                            {#if data.ind2.hasOwnProperty(ind2)}
                                {#each data.ind2[ind2].map(item => item.ind1).sort((a, b) => a.localeCompare(b)) as value}
                                    <option value="{value}">{value}</option>
                                {/each}
                            {/if}
                        </select>
                    </div>
                </div>

                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Длина, мм</label>
                        <input type="number" class="form-control" step="50" min="600" bind:value={dlina}>
                    </div>
                </div>
            </div>


            <div class="col-12">
                <PodokonnikMaterialList list={data.materials} bind:components={components} />

            </div>



            <div class="col-12 col-sm-7">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <div class="input-wrapper">
                                    <label class="form-label">Примечание</label>
                                    <textarea class="form-control" bind:value={$comment}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-6  col-sm-3">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}
